import { videos } from "@/mocks/videos";
import type { VideoItem } from "@/mocks/videos";

export interface FilterParams {
  type?: string;
  region?: string;
  year?: string;
  sort?: string;
  keyword?: string;
}

export function getVideoById(id: number): VideoItem | undefined {
  return videos.find((item) => item.id === id);
}

export function getVideosByType(type: string): VideoItem[] {
  return videos.filter((item) => item.type === type);
}

export function sortVideos(list: VideoItem[], sort?: string): VideoItem[] {
  const copy = [...list];
  if (sort === "new") {
    return copy.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  }
  if (sort === "rating") {
    return copy.sort((a, b) => b.rating - a.rating);
  }
  return copy.sort((a, b) => b.hot - a.hot);
}

export function filterVideos(params: FilterParams): VideoItem[] {
  const { type, region, year, sort, keyword } = params;
  let list = [...videos];

  if (type) {
    list = list.filter((item) => item.type === type);
  }
  if (region && region !== "全部") {
    list = list.filter((item) => item.region === region);
  }
  if (year && year !== "全部") {
    list = list.filter((item) => String(item.year) === year);
  }
  if (keyword && keyword.trim()) {
    const kw = keyword.trim().toLowerCase();
    list = list.filter((item) => {
      const haystack = [item.title, item.director, ...item.actors, ...item.tags]
        .join(" ")
        .toLowerCase();
      return haystack.includes(kw);
    });
  }
  return sortVideos(list, sort);
}

export function getHotVideos(limit = 8): VideoItem[] {
  return sortVideos(videos, "hot").slice(0, limit);
}

export function getLatestVideos(limit = 8): VideoItem[] {
  return sortVideos(videos, "new").slice(0, limit);
}

export function getRelatedVideos(current: VideoItem, limit = 6): VideoItem[] {
  const scored = videos
    .filter((item) => item.id !== current.id)
    .map((item) => {
      let score = 0;
      if (item.type === current.type) score += 3;
      if (item.region === current.region) score += 1;
      score += item.tags.filter((tag) => current.tags.includes(tag)).length * 2;
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.hot - a.item.hot);
  return scored.slice(0, limit).map((entry) => entry.item);
}